import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            fontWeight: 'bold',
          },
        },
      },
    },
  },
});

export default theme;

